import axios from "axios";

/**
 * Consulta los datos del tablero de soportes históricos
 * @param {Object} data - Datos de búsqueda
 * @returns {Promise<Array>} Lista de registros obtenidos
 */

export async function getAllValues(data) {
  try {
    const response = await axios.get(
      "/ProcesosP/ValoracionAlfanumerico/GetAllData?descripcion=" + data,
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function getAllDataTableMax() {
  try {
    const response = await axios.get(
      "/ProcesosP/ValoracionAlfanumerico/GetAllDataTableMax",
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function getValoracionAlfanumerico(data) {
  try {
    const response = await axios.post(
      "/ProcesosP/ValoracionAlfanumerico/Get",
      data,
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function upsertValoracionAlfanumerico(data) {
  try {
    const response = await axios.post(
      "/ProcesosP/ValoracionAlfanumerico/Upsert",
      data,
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}
